/**
 * Phase F — TableDialog shell.
 *
 * Routes to one of three status-specific forms:
 *   - available  → AvailableForm
 *   - reserved   → ReservedForm
 *   - occupied   → OccupiedForm
 *
 * Header shows the table `code` (top-left) per design decision #5
 * ("Room Number" = table code) plus a close icon (top-right).
 */
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";
import AvailableForm from "@/components/dialog/AvailableForm";
import ReservedForm from "@/components/dialog/ReservedForm";
import OccupiedForm from "@/components/dialog/OccupiedForm";

export default function TableDialog({ table, open, onClose }) {
  if (!table) return null;

  let Body;
  switch (table.status) {
    case "reserved":
      Body = ReservedForm;
      break;
    case "occupied":
      Body = OccupiedForm;
      break;
    default:
      Body = AvailableForm;
  }

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid={`table-dialog-${table.code}`}
        className="w-[calc(100%-2rem)] max-w-[440px] max-h-[calc(100vh-2rem)] overflow-y-auto rounded-lg p-0 gap-0 [&>button]:hidden"
      >
        {/* Header — only the table code */}
        <div
          className="flex items-center justify-between px-5 py-4 border-b"
          style={{ borderColor: "#E5E7EB" }}
        >
          <span
            data-testid="dialog-room-code"
            className="text-lg font-bold"
            style={{ color: "#1A1A1A" }}
          >
            {table.code}
          </span>
          <button
            data-testid="dialog-close-btn"
            onClick={onClose}
            className="rounded-md p-1.5 hover:bg-gray-100 transition-colors"
            aria-label="Close"
          >
            <X size={20} style={{ color: "#6B7280" }} />
          </button>
        </div>

        {/* Body — variant-specific form */}
        <Body table={table} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}
